module.exports = __webpack_public_path__ + "img/Promolider.20202c40.png";